var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecentlyAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 0.666748H1.66732C0.927318 0.666748 0.340651 1.26008 0.340651 2.00008L0.333984 10.0001C0.333984 10.7401 0.927318 11.3334 1.66732 11.3334H12.334C13.074 11.3334 13.6673 10.7401 13.6673 10.0001V2.00008C13.6673 1.26008 13.074 0.666748 12.334 0.666748ZM4.66732 8.00008H3.86732L2.16732 5.66675V8.00008H1.33398V4.00008H2.16732L3.83398 6.33341V4.00008H4.66732V8.00008ZM8.00065 4.84008H6.33398V5.58675H8.00065V6.42675H6.33398V7.16675H8.00065V8.00008H5.33398V4.00008H8.00065V4.84008ZM12.6673 7.33341C12.6673 7.70008 12.3673 8.00008 12.0007 8.00008H9.33398C8.96732 8.00008 8.66732 7.70008 8.66732 7.33341V4.00008H9.50065V7.00675H10.254V4.66008H11.0873V7.00008H11.834V4.00008H12.6673V7.33341Z",
    fill: "#E59423"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyAdded);
export default __webpack_public_path__ + "static/media/recentlyAdded.e09f3d88cd33a79db555c830c0e71d9a.svg";
export { ForwardRef as ReactComponent };